export default __webpack_public_path__ + "static/media/data.ea72253c.xlsx";